var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { withStyles, FormControl, FormControlLabel, FormHelperText, Checkbox as MuiCheckbox, makeStyles, } from '@material-ui/core';
import React, { useState, useEffect, useRef, } from 'react';
// onchange example----------------------------------------------------
// export const RadioInputChange = UpdateData => (e, value: string) => {
//     UpdateData({ [e.target.name]: value });
// }
// const----------------------------------------------------
export var EmptyCheckboxMsg = '如果你要繼續執行，請勾選這個核取方塊。';
// style----------------------------------------------------
var useCkeckboxStyle = makeStyles(function () { return ({
    root: function (props) { return (props.ckeckboxStyle ? props.ckeckboxStyle : {}); },
}); });
var useLabelStyle = makeStyles(function () { return ({
    root: { margin: 0 },
    label: function (props) { return (props.labelStyle ? props.labelStyle : {}); },
}); });
export var StyleFormControl = withStyles(function () { return ({
    root: {
    // padding: '5px',
    },
}); })(FormControl);
export var StyleFormControlLabel = withStyles({
    root: {
        marginLeft: '0px',
        marginRight: '5px',
    },
    label: {
        fontSize: '1em',
        fontWeight: 'inherit',
    },
})(FormControlLabel);
export var StyleFormHelperText = withStyles(function () { return ({
    root: {
        margin: '0',
    },
}); })(FormHelperText);
export var StyleCheckbox = withStyles(function () { return ({
    root: {
        padding: '3px',
    },
}); })(MuiCheckbox);
// component----------------------------------------------------
var CheckBox = function (props) {
    var checked = props.checked, onChange = props.onChange, _a = props.inputRef, inputRef = _a === void 0 ? useRef() : _a, _b = props.verifyBeforeChange, verifyBeforeChange = _b === void 0 ? false : _b, error = props.error, helperText = props.helperText, label = props.label, labelStyle = props.labelStyle, ckeckboxStyle = props.ckeckboxStyle, other = __rest(props, ["checked", "onChange", "inputRef", "verifyBeforeChange", "error", "helperText", "label", "labelStyle", "ckeckboxStyle"]);
    var checkboxClasses = useCkeckboxStyle(props);
    var labelClasses = useLabelStyle(props);
    var _c = useState(''), message = _c[0], setMessage = _c[1];
    var _d = useState(verifyBeforeChange), firstVerify = _d[0], setFirstVerify = _d[1];
    useEffect(function () {
        setFirstVerify(verifyBeforeChange);
    }, [verifyBeforeChange]);
    useEffect(function () {
        // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
        if (!firstVerify)
            return;
        // 驗 HTML validation
        if (inputRef.current) {
            var validationMessage = inputRef.current.validationMessage;
            if (validationMessage.length > 0) {
                setMessage(validationMessage);
                return;
            }
        }
        // 先前檢驗都 pass
        setMessage('');
    }, [checked, firstVerify]);
    return (React.createElement(StyleFormControl, { error: error || message.length > 0 },
        React.createElement(StyleFormControlLabel, { classes: labelClasses, inputRef: inputRef, control: React.createElement(StyleCheckbox, __assign({ checked: checked, classes: checkboxClasses }, other, { onChange: function (e, checkedVal) {
                    setFirstVerify(true);
                    if (onChange)
                        onChange(e, checkedVal);
                } })), label: label, style: !label ? { margin: 0 } : {} }),
        React.createElement(StyleFormHelperText, null, helperText || message)));
};
export default CheckBox;
